import { ArnUserConditionService } from './ArnUserConditionService';
import { ArnConditionService } from '../ArnConditionService';
import {
  ArnConditionsPayload,
  IsWhitelistedCondition,
} from '@arianee/arn-types';
import { ArnDelegateConditionService } from '../ArnDelegateConditionService';

export class DefaultUserConditionService
  extends ArnDelegateConditionService
  implements ArnUserConditionService
{
  constructor(condition: ArnConditionService) {
    super(condition);
  }

  async isListedIn(...listNames: string[]): Promise<boolean> {
    const whitelistsConditions = listNames.map((name) => {
      return new IsWhitelistedCondition({ name });
    });
    const conditionsPayload: ArnConditionsPayload = {
      and: whitelistsConditions,
    };
    const result = await this.condition.execute(conditionsPayload);
    return result.success;
  }
}
